// extracted by mini-css-extract-plugin
module.exports = {"payouts":"Payouts_payouts__D3rbp","chips":"Payouts_chips__1sS2x"};